import React from 'react';
import { Navigate } from 'react-router-dom';

import { useUserInfo } from './kratos/common';

export default function Top() {
  const { userType } = useUserInfo();

  return (
    userType === 'guest'
    ? <Navigate to="/login" />
    : userType === 'authenticated'
    ? <Navigate to="/settings" />
    : <></>
  );
}
